import { Tab, Tabs, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";

export const NotificationTabs = ({ filters, setFilters }) => {
    return (
        <Tabs>
        <TabList>
          <Tab
            onClick={() =>
              setFilters({ ...filters, notification_status: "all" })
            }
          >
            All
          </Tab>
          <Tab
            onClick={() =>
              setFilters({ ...filters, notification_status: "completed" })
            }
          >
            Completed
          </Tab>
          <Tab
            onClick={() =>
              setFilters({ ...filters, notification_status: "pending" })
            }
          >
            Scheduled
          </Tab>
        </TabList>
      </Tabs>
    )
}